import { render, staticRenderFns } from "./JobOfferDetailsCard.htm?vue&type=template&id=0d061493&scoped=true&"
import script from "./JobOfferDetailsCard.ts?vue&type=script&lang=js&"
export * from "./JobOfferDetailsCard.ts?vue&type=script&lang=js&"
import style0 from "./JobOfferDetailsCard.scss?vue&type=style&index=0&id=0d061493&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d061493",
  null
  
)

export default component.exports